<template>
  <div>
    
    <h1 style="text-align: center;" v-if="showImg('Araçatuba')">SAMEB - Sistema de Avaliação Municipal da Educação Básica</h1>
    <h1 style="text-align: center;" v-if="showImg('Araçatuba')">Araçatuba - SP</h1>
    <h1 v-else>Sistema Municipal de Avaliação</h1>
    <v-img
        v-if="showImg('Guaraci')"
        style="max-width: 50%; max-height: 50%;"
        src="../../assets/logo_guaraci.jpg"
    />
    <v-img
        v-if="showImg('Araçatuba')"
        style="max-width: 50%; max-height: 50%; margin: auto"
        src="../../assets/aracatuba.png"
    />
  </div>
</template>

<script>

  import {mapGetters} from "vuex";

  export default {

    data() {
      return {
        caminho: "../../assets/Prova.png"
      }
    },
    created() {

    },
    methods: {

      showImg(owner){
        if(this.user != null && this.user.owner.nome == owner)
          return true;
        else return false;
      }
    },
    watch: {
      user () {

      }
    },
    computed: {
      ...mapGetters({
        user: 'Login/user',
      })
    },
  }
</script>